import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { CheckoutFormsState } from '../checkout-forms.state';
import { reducer } from './checkout-forms.reducers';

export function getReducers(): ActionReducerMap<CheckoutFormsState, any> {
  return {
    formsObjectValue: reducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CheckoutFormsState>> = new InjectionToken<
  ActionReducerMap<CheckoutFormsState>
>('CheckoutFormsReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
